module.exports = __webpack_public_path__ + "static/payment100-5115cb593fe84c61e477ab116cf58b73.jpg";